var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-sale-detail-browse", {
    attrs: { "show-reports": "", "show-actions": "", "browse-id": 7 },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }